const wowApp = require('angular').module('wowApp.auth');

const { AbnLookupService } = require('./abn-lookup.service');
const { AbnComponentDefinition } = require('./abn.component');
const abnValidatorDirective = require('./abn-validator.directive');

wowApp.service('AbnLookupService', AbnLookupService)
    .component('wowAbn', AbnComponentDefinition)
    .directive('wowAbnValidator', ['$q', '$timeout', 'AbnLookupService', abnValidatorDirective]);



// WEBPACK FOOTER //
// ./src/auth/abn/index.js